export default {
  title: 'Veranstaltungseinstellungen',
  coloredOccupancyTitle: 'Farbliche Markierung der Belegung',
  coloredOccupancyDescription:
    'Ab wie viel Prozent soll die jeweilige Farbe für die Belegung angezeigt werden?',
  colors: { green: 'Grün', yellow: 'Gelb', red: 'Rot' },
  period: 'Zeitraum bis ein abgelaufenes Event gelöscht wird',
  error: {
    loading: 'Veranstaltungseinstellungen konnten nicht geladen werden',
    update: 'Veranstaltungseinstellungen konnten nicht aktualisiert werden'
  },
  success: { update: 'Veranstaltungseinstellungen wurden erfolgreich aktualisiert' }
};
